export const isFullscreenSupported = !!document.fullscreenEnabled || !!(document as any).webkitFullscreenEnabled;
